export const FormarttedDate = ({ date }) => {
    const parsedDate = new Date(date);
    const formattedDate = `${parsedDate.getDate().toString().padStart(2, '0')}/${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${(parsedDate.getFullYear()-2000)}`;
    const formattedTime = `${parsedDate.getHours()}:${parsedDate.getMinutes()}`;
    return (
      <>
      {formattedDate} {formattedTime}
      </>
    );
  };